/*@ngInject*/
const UserGroupEditorHeaderController = function ($rootScope, $scope, $element, $stateParams, $state,
                                                        $uibModal, localization, configurationConstant,
                                                        configurationMediator, coreConstant,
                                                        modalUtil, userGroupAction, userGroupEditorModel,
                                                   userGroupActionsUtil, loadingBarHandler, userMediator) {


    $element.addClass('userGroupEditorHeader');
    this.translations = null;
    this.actions = [];
    this.userGroup = {};
    this.context = {
        identifier: 'userGroupEditorHeader',
        actions: {},
        fallthrough: null,
        model: {
            contextType: coreConstant.CONTEXT_NONE
        }
    };
    this.context.actions[coreConstant.CONTEXT_NONE] = '';
    this.actionSubTexts = {};
    this.actionsTimeLastModified = '';

    this.$onInit = function () {
        localization.getTranslationByKey('userGroupEditorHeader').then((translations) => {
            this.translations = translations;
            this.actions = [];
            this.loadActions();
        });
    };

    this.loadActions = function () {
        let staticActions = [],
            allActions = [];
        userMediator.loadUserGroupActions($stateParams.userGroupId).then((actions) => {
            allActions.push({
                actions: actions.actions,
                contextType: this.context.model.contextType
            });
            this.actions = allActions;
            this.actionsTimeLastModified = new Date().getTime();
            this.processActions(allActions, false);
        });
    };

    $scope.$on(coreConstant.event.USER_GROUP_UPDATED, (event, userGroupId) => {
        if (parseInt($stateParams.userGroupId) === userGroupId) {
            this.userGroup = userGroupEditorModel.getUserGroup(userGroupId);
            this.processActions(this.actions);
        }
    });

    this.processActions = function (actions) {
        this.actions = actions;
        this.actionSubTexts = {};

        _.each(this.actions, function (subAction) {
            _.each(subAction.actions, function (action) {
                if (action.name === userGroupAction.SAVE) {
                    action.enabled = userGroupEditorModel.hasUnsavedChanges && userGroupEditorModel.isValid;
                } else if (action.name === userGroupAction.DISCARD) {
                    action.enabled = parseInt($stateParams.userGroupId) === -1 ||
                        (userGroupEditorModel.getUserGroup($stateParams.userGroupId) && userGroupEditorModel.hasUnsavedChanges);
                }

                if (action.name === userGroupAction.SAVE && userGroupEditorModel.hasUnsavedChanges) {
                    this.actionSubTexts[action.name] = {
                        class: 'unsavedChanges',
                        text: _.get(this.translations, 'unsavedChanges')
                    };
                }
            }.bind(this));
        }.bind(this));

        this.actionsTimeLastModified = new Date().getTime();
    };

    this.handleAction = function (action) {
        if (action.enabled) {
            switch (action.name) {
                case userGroupAction.SAVE:
                    if(this.userGroup.id === -1) {
                        userGroupActionsUtil.createUserGroup($stateParams.userGroupId, this.translations).then(function (userGroup) {
                            $stateParams.userGroupId = userGroup.id;
                            userGroupEditorModel.hasUnsavedChanges = false;
                            userGroupEditorModel.isValid = false;
                            userGroupEditorModel.setUserGroup(userGroup);
                            $state.reload();
                        });
                    } else {
                        userGroupActionsUtil.saveUserGroup($stateParams.userGroupId, this.translations).then(function (userGroups) {
                            userGroupEditorModel.hasUnsavedChanges = false;
                            userGroupEditorModel.isValid = false;
                            $state.reload();
                        });
                    }
                    break;
                case userGroupAction.DISCARD:
                    userGroupActionsUtil.discard(this.userGroup.id, this.translations);
                    break;
                default:
                    modalUtil.showActionNotImplementedModal(action.name);
                    break;
            }
        }
    };

    $scope.$on('$stateChangeStart', function (event, toState, toParams, fromState) {
        let isCurrentStateUserGroupsManager = _.startsWith(fromState.name, 'userGroupEditor'),
            isTargetSameAsCurrent = toState.name === fromState.name;
        if (toState.name === 'login') {
            return;
        }
        if (userGroupEditorModel.hasUnsavedChanges
            && isCurrentStateUserGroupsManager
            && !isTargetSameAsCurrent
            && userGroupEditorModel.getUserGroup(parseInt($stateParams.userGroupId))) {

            event.preventDefault();
            if (userGroupEditorModel.isValid) {
                if(this.userGroup.id === -1) {
                    userGroupActionsUtil.createUserGroup($stateParams.userGroupId, this.translations).then(function (userGroup) {
                        userGroupEditorModel.hasUnsavedChanges = false;
                        userGroupEditorModel.isValid = false;
                        $state.go(toState, toParams);
                    });
                } else {
                    userGroupActionsUtil.saveUserGroup($stateParams.userGroupId, this.translations).then(function (userGroups) {
                        userGroupEditorModel.hasUnsavedChanges = false;
                        userGroupEditorModel.isValid = false;
                        $state.go(toState, toParams);
                    });
                }
            } else {
                $rootScope.$broadcast(coreConstant.event.SHOW_FADING_NOTIFICATION, _.get(this.translations, 'invalidUserGroup'));
            }
        } else {
            // there are no changes to be saved, do nothing
        }
    }.bind(this));
};

angular.module('umCore')
    .controller('userGroupEditorHeaderController', UserGroupEditorHeaderController);
